function retrieveFinalPaymentTerms(companyId) {
    return window.tenantAxios.get(`/company/${companyId}/final-payment-terms`);
}

function updateFinalPaymentTerms(companyId, finalPaymentTerms) {
    return window.tenantAxios.patch(`/company/${companyId}/final-payment-terms`, finalPaymentTerms);
}

export default {
    retrieveFinalPaymentTerms,
    updateFinalPaymentTerms,
};
